<template>
  <div class="account-tab-item">
    <div class="account-tab-item__head-mob" v-if="isMob">
      <div class="account-tab-item__filter-btn-wrap">
        <button type="button"
                class="account-tab-item__filter-btn"
                @click.prevent="onOpenFilterMob">
          <BaseSvg name="ico-filter" class="_filter" width="1.3rem" height="1.3rem"/>
          <span>{{$tResumeList('Set filters')}}</span>
          <BaseSvg name="ico-arrow-light" class="_arrow" width=".4rem" height=".6rem"/>
        </button>
      </div>
    </div>
    <table class="account-tab-item__table" v-if="!isMob">
      <thead>
        <tr>
          <th>
            <div class="select-dropdown _left">
              <div class="select-dropdown__trigger-wrap">
                <button type="button" class="select-dropdown__trigger"
                        @click.prevent="showFilterFindName = true">
                  <span>{{$tResumeList('Find employee')}}</span>
                  <BaseSvg v-if="true" class="select-dropdown__trigger-loupe" name="ico-loupe"/>
                </button>

                <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterFindName = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                  <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                </div>
              </div>
              <transition name="dropdown">
                <div
                  v-if="showFilterFindName"
                  v-click-out="() => this.showFilterFindName = false"
                  class="select-dropdown__dropdown"
                >
                  <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterFindName = false"
                  >
                    <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                    />
                  </button>

                  <div class="select-dropdown__options filter-checkbox">
                    <div class="filter-checkbox__input">
                      <BaseInput :placeholder="$tResumeList('Start typing a name')"/>
                      <BaseSvg name="ico-loupe"/>
                    </div>
                    <ul class="filter-checkbox__list">
                      <li v-for="index in 10"
                          :key="index">
                        <BaseCheckbox class="_user">
                          <template v-slot:label>
                            <span style="background-image: url('https://thispersondoesnotexist.com/image')"
                                  class="checkbox__user-avatar"
                            ></span>
                            <span class="checkbox__user-name">Lorem Name</span>
                          </template>
                        </BaseCheckbox>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </th>
          <th>
            <div class="select-dropdown">
              <div class="select-dropdown__trigger-wrap">
                <button type="button" class="select-dropdown__trigger"
                        @click.prevent="showFilterVacancy = true">
                  <span>{{$tResumeList('Vacancy')}}</span>
                  <BaseSvg  v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                </button>

                <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterVacancy = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                  <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                </div>
              </div>
              <transition name="dropdown">
                <div
                  v-if="showFilterVacancy"
                  v-click-out="() => this.showFilterVacancy = false"
                  class="select-dropdown__dropdown"
                >
                  <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterVacancy = false"
                  >
                    <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                    />
                  </button>

                  <div class="select-dropdown__options filter-checkbox">
                    <ul class="filter-checkbox__list">
                      <li v-for="index in 10"
                          :key="index">
                        <BaseCheckbox label="asdad"/>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </th>
          <th>
            <div class="select-dropdown">
              <div class="select-dropdown__trigger-wrap">
                <button type="button" class="select-dropdown__trigger"
                        @click.prevent="showFilterResponse = true">
                  <span>{{$tResumeList('Response date')}}</span>
                  <BaseSvg  v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                </button>

                <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterResponse = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                  <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                </div>
              </div>
              <transition name="dropdown">
                <div
                  v-if="showFilterResponse"
                  v-click-out="() => this.showFilterResponse = false"
                  class="select-dropdown__dropdown"
                >
                  <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterResponse = false"
                  >
                    <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                    />
                  </button>

                  <div class="select-dropdown__options">
                    date
                  </div>
                </div>
              </transition>
            </div>
          </th>
          <th>
            <div class="select-dropdown">
              <div class="select-dropdown__trigger-wrap">
                <button type="button" class="select-dropdown__trigger"
                        @click.prevent="showFilterStage = true">
                  <span>{{$tResumeList('Stage of registration')}}</span>
                  <BaseSvg  v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                </button>

                <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterStage = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                  <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                </div>
              </div>
              <transition name="dropdown">
                <div
                  v-if="showFilterStage"
                  v-click-out="() => this.showFilterStage = false"
                  class="select-dropdown__dropdown"
                >
                  <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterStage = false"
                  >
                    <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                    />
                  </button>

                  <div class="select-dropdown__options filter-checkbox _short">
                    <ul class="filter-checkbox__list">
                      <li>
                        <BaseCheckbox label="rdcz adasd asd"/>
                      </li>
                      <li>
                        <BaseCheckbox label="rdcz adasd asd"/>
                      </li>
                      <li>
                        <BaseCheckbox label="rdcz adasd asd"/>
                      </li>
                      <li>
                        <BaseCheckbox label="rdcz adasd asd"/>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </th>
          <th v-if="!full"></th>
          <th v-if="full">
            <div class="select-dropdown">
              <div class="select-dropdown__trigger-wrap">
                <button type="button" class="select-dropdown__trigger"
                        @click.prevent="showFilterFindLeads = true">
                  <span class="select-dropdown__filter-name">{{$tResumeList('Who leads')}}</span>
                  <BaseSvg v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                </button>

                <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterFindLeads = true"
                          class="select-dropdown__selected-text"
                    >Name Lorem {{$tResumeList('and more')}} 5</span>
                  <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                </div>
              </div>

              <transition name="dropdown">
                <div
                  v-if="showFilterFindLeads"
                  v-click-out="() => this.showFilterFindLeads = false"
                  class="select-dropdown__dropdown"
                >
                  <button
                    type="button"
                    class="select-dropdown__close"
                    @click.prevent="showFilterFindLeads = false"
                  >
                    <BaseSvg
                      name="ico-close"
                      width=".8rem"
                      height=".8rem"
                    />
                  </button>

                  <div class="select-dropdown__options filter-checkbox">
                    <div class="filter-checkbox__input">
                      <BaseInput :placeholder="$tResumeList('Start typing a name')"/>
                      <BaseSvg name="ico-loupe"/>
                    </div>
                    <ul class="filter-checkbox__list">
                      <li v-for="index in 10"
                          :key="index">
                        <BaseCheckbox class="_user">
                          <template v-slot:label>
                            <span style="background-color: #b3a3c1"
                                  class="checkbox__user-avatar"
                            >LN</span>
                            <span class="checkbox__user-name">Lorem Name</span>
                          </template>
                        </BaseCheckbox>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ResumeTabItemRegRow :full="full"/>
        <ResumeTabItemRegRow :full="full"/>
        <ResumeTabItemRegRow :full="full"/>
      </tbody>
    </table>
    <div v-else class="account-tab-item__group">
      <ResumeTabItemRegRow :full="full" is-mob/>
      <ResumeTabItemRegRow :full="full" is-mob/>
      <ResumeTabItemRegRow :full="full" is-mob/>
    </div>

    <div class="account-tab-item__pagination-wrap">
      <Pagination class="account-tab-item__pagination" :quantity="5"/>
      <button type="button" class="account-tab-item__pagination-btn base-btn base-btn--green">
        <BaseSvg name="ico-plus" width="1.3rem" height="1.3rem"/>
        <span class="base-btn__text">{{$tResumeList('Add resume')}}</span>
      </button>
    </div>

    <transition name="fade">
      <div v-if="showFilterMob" class="account-tab-item__mob-filter">
        <div class="account-tab-item__mob-filter-content" v-click-out="onCloseFilterMob">
          <div class="account-tab-item__mob-filter-head">
            <button class="account-tab-item__back-btn" @click="onCloseFilterMob">
              <BaseSvg name="ico-arrow-light" class="_arrow" width=".4rem" height=".6rem"/>
              <span>{{$tResumeList('Back')}}</span>
            </button>
          </div>
          <div class="account-tab-item__mob-filter-group">
            <div class="account-tab-item__mob-filter-item">
              <div class="select-dropdown _left">
                <div class="select-dropdown__trigger-wrap">
                  <button type="button" class="select-dropdown__trigger"
                          @click.prevent="showFilterFindName = true">
                    <span>{{$tResumeList('Find employee')}}</span>
                    <BaseSvg v-if="true" class="select-dropdown__trigger-loupe" name="ico-loupe"/>
                  </button>

                  <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterFindName = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                    <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                  </div>
                </div>
                <transition name="dropdown">
                  <div
                    v-if="showFilterFindName"
                    v-click-out="() => this.showFilterFindName = false"
                    class="select-dropdown__dropdown"
                  >
                    <button
                      type="button"
                      class="select-dropdown__close"
                      @click.prevent="showFilterFindName = false"
                    >
                      <BaseSvg
                        name="ico-close"
                        width=".8rem"
                        height=".8rem"
                      />
                    </button>

                    <div class="select-dropdown__options filter-checkbox">
                      <div class="filter-checkbox__input">
                        <BaseInput :placeholder="$tResumeList('Start typing a name')"/>
                        <BaseSvg name="ico-loupe"/>
                      </div>
                      <ul class="filter-checkbox__list">
                        <li v-for="index in 10"
                            :key="index">
                          <BaseCheckbox class="_user">
                            <template v-slot:label>
                            <span style="background-image: url('https://thispersondoesnotexist.com/image')"
                                  class="checkbox__user-avatar"
                            ></span>
                              <span class="checkbox__user-name">Lorem Name</span>
                            </template>
                          </BaseCheckbox>
                        </li>
                      </ul>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="account-tab-item__mob-filter-item">
              <div class="select-dropdown _left">
                <div class="select-dropdown__trigger-wrap">
                  <button type="button" class="select-dropdown__trigger"
                          @click.prevent="showFilterVacancy = true">
                    <span>{{$tResumeList('Vacancy')}}</span>
                    <BaseSvg  v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                  </button>

                  <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterVacancy = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                    <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                  </div>
                </div>
                <transition name="dropdown">
                  <div
                    v-if="showFilterVacancy"
                    v-click-out="() => this.showFilterVacancy = false"
                    class="select-dropdown__dropdown"
                  >
                    <button
                      type="button"
                      class="select-dropdown__close"
                      @click.prevent="showFilterVacancy = false"
                    >
                      <BaseSvg
                        name="ico-close"
                        width=".8rem"
                        height=".8rem"
                      />
                    </button>

                    <div class="select-dropdown__options filter-checkbox">
                      <ul class="filter-checkbox__list">
                        <li v-for="index in 10"
                            :key="index">
                          <BaseCheckbox label="asdad"/>
                        </li>
                      </ul>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="account-tab-item__mob-filter-item">
              <div class="select-dropdown _left">
                <div class="select-dropdown__trigger-wrap">
                  <button type="button" class="select-dropdown__trigger"
                          @click.prevent="showFilterResponse = true">
                    <span>{{$tResumeList('Response date')}}</span>
                    <BaseSvg  v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                  </button>

                  <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterResponse = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                    <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                  </div>
                </div>
                <transition name="dropdown">
                  <div
                    v-if="showFilterResponse"
                    v-click-out="() => this.showFilterResponse = false"
                    class="select-dropdown__dropdown"
                  >
                    <button
                      type="button"
                      class="select-dropdown__close"
                      @click.prevent="showFilterResponse = false"
                    >
                      <BaseSvg
                        name="ico-close"
                        width=".8rem"
                        height=".8rem"
                      />
                    </button>

                    <div class="select-dropdown__options">
                      date
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="account-tab-item__mob-filter-item">
              <div class="select-dropdown _left">
                <div class="select-dropdown__trigger-wrap">
                  <button type="button" class="select-dropdown__trigger"
                          @click.prevent="showFilterStage = true">
                    <span>{{$tResumeList('Stage of registration')}}</span>
                    <BaseSvg  v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                  </button>

                  <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterStage = true"
                          class="select-dropdown__selected-text"
                    >some {{$tResumeList('and more')}} 5</span>
                    <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                  </div>
                </div>
                <transition name="dropdown">
                  <div
                    v-if="showFilterStage"
                    v-click-out="() => this.showFilterStage = false"
                    class="select-dropdown__dropdown"
                  >
                    <button
                      type="button"
                      class="select-dropdown__close"
                      @click.prevent="showFilterStage = false"
                    >
                      <BaseSvg
                        name="ico-close"
                        width=".8rem"
                        height=".8rem"
                      />
                    </button>

                    <div class="select-dropdown__options filter-checkbox _short">
                      <ul class="filter-checkbox__list">
                        <li>
                          <BaseCheckbox label="rdcz adasd asd"/>
                        </li>
                        <li>
                          <BaseCheckbox label="rdcz adasd asd"/>
                        </li>
                        <li>
                          <BaseCheckbox label="rdcz adasd asd"/>
                        </li>
                        <li>
                          <BaseCheckbox label="rdcz adasd asd"/>
                        </li>
                      </ul>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div v-if="full" class="account-tab-item__mob-filter-item">
              <div class="select-dropdown _left">
                <div class="select-dropdown__trigger-wrap">
                  <button type="button" class="select-dropdown__trigger"
                          @click.prevent="showFilterFindLeads = true">
                    <span class="select-dropdown__filter-name">{{$tResumeList('Who leads')}}</span>
                    <BaseSvg v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
                  </button>

                  <div v-if="false" class="select-dropdown__selected">
                    <span @click.prevent="showFilterFindLeads = true"
                          class="select-dropdown__selected-text"
                    >Name Lorem {{$tResumeList('and more')}} 5</span>
                    <span @click="onClear" class="select-dropdown__selected-del">
                      <BaseSvg  name="ico-close"/>
                    </span>
                  </div>
                </div>

                <transition name="dropdown">
                  <div
                    v-if="showFilterFindLeads"
                    v-click-out="() => this.showFilterFindLeads = false"
                    class="select-dropdown__dropdown"
                  >
                    <button
                      type="button"
                      class="select-dropdown__close"
                      @click.prevent="showFilterFindLeads = false"
                    >
                      <BaseSvg
                        name="ico-close"
                        width=".8rem"
                        height=".8rem"
                      />
                    </button>

                    <div class="select-dropdown__options filter-checkbox">
                      <div class="filter-checkbox__input">
                        <BaseInput :placeholder="$tResumeList('Start typing a name')"/>
                        <BaseSvg name="ico-loupe"/>
                      </div>
                      <ul class="filter-checkbox__list">
                        <li v-for="index in 10"
                            :key="index">
                          <BaseCheckbox class="_user">
                            <template v-slot:label>
                            <span style="background-color: #b3a3c1"
                                  class="checkbox__user-avatar"
                            >LN</span>
                              <span class="checkbox__user-name">Lorem Name</span>
                            </template>
                          </BaseCheckbox>
                        </li>
                      </ul>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import ResumeTabItemRegRow from '@/components/resumeList/ResumeTabItemRegRow'
  import Pagination from '@/components/Pagination'
  import {blockScroll, unBlockScroll} from '@/helpers/scroll'
  export default {
    name: 'ResumeTabItemReg',
    components: {Pagination, ResumeTabItemRegRow},
    props: {
      full: {
        type: Boolean,
        default: false
      },
      isMob: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showFilterFindName: false,
        showFilterVacancy: false,
        showFilterResponse: false,
        showFilterStage: false,
        showFilterFindLeads: false,
        showFilterMob: false,
        timer: null
      }
    },
    methods: {
      onClear() {
        console.log('clear')
      },
      onOpenFilterMob() {
        blockScroll()
        this.showFilterMob = true
      },
      onCloseFilterMob() {
        unBlockScroll()
        this.showFilterMob = false
      },
      checkMob() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (!this.isMob) {
            this.onCloseFilterMob()
          }
        }, 200)
      }
    },
    mounted() {
      window.addEventListener('resize', this.checkMob)
    },
    beforeDestroy() {
      this.onCloseFilterMob()
      window.removeEventListener('resize', this.checkMob)
    }
  }
</script>

<style>

</style>
